import { axios } from "../common";

export const postApproval = async (payload, type) => {
  const { data } = await axios.post(type, payload);
  return data;
};
